module.exports = __webpack_public_path__ + "assets/time-litsview.216d104b.svg";